import { ReactElement } from 'react';
import { useBrandNavigate } from '../../modules/navigation/UseBrandNavigate';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';
import { PageRoutes } from '../../modules/navigation/PageRoutes';
import { LoginErrorPageViewProps } from './LoginErrorPageViewProps';

export function LoginErrorPage(): ReactElement {
  const navigate = useBrandNavigate();
  const viewProvider = useViewProvider();

  const onClick = (): void => {
    navigate(PageRoutes.LoginByVin);
  };

  const viewProps: LoginErrorPageViewProps = {
    onClick,
  };

  return viewProvider.renderLoginErrorPage(viewProps);
}
